export function errorIsFromApi(input: unknown): boolean {
  if (input === null) {
    return false;
  }

  if (typeof input !== "object") {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(input, "error")) {
    return false;
  }
  const objectWithError: { error: unknown } = input as { error: unknown };

  if (typeof objectWithError.error !== "object") {
    return false;
  }
  const objectWithErrorObject: { error: object } = input as { error: object };

  if (
    !Object.prototype.hasOwnProperty.call(objectWithErrorObject.error, "code")
  ) {
    return false;
  }

  if (
    !Object.prototype.hasOwnProperty.call(
      objectWithErrorObject.error,
      "message"
    )
  ) {
    return false;
  }
  const objectWithErrorObjectWithCodeAndMessage = input as {
    error: { code: unknown; message: unknown };
  };

  if (typeof objectWithErrorObjectWithCodeAndMessage.error.code !== "number") {
    return false;
  }

  if (
    typeof objectWithErrorObjectWithCodeAndMessage.error.message !== "string"
  ) {
    return false;
  }

  return true;
}
